import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';

import it from './translation.it.json';
import en from './translation.en.json';
import es from './translation.es.json';
import pl from './translation.pl.json';

let language = window.localStorage.getItem('i18nextLng') || 'it';

const resources = {
  it: it,
  en: en,
  es: es,
  pl: pl,
};

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
